/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import common from '../common/index';

export default {
  setDeclinedReason(state, reason) {
    state.declineReason = reason;
  },
  setSearchedUsers(state, users) {
    state.searchedUsers = users.reduce((obj, user) => ({ ...obj, [user.username]: user }), {});
  },
  addToExtraUsers(state, user) {
    state.extraUsers = {
      ...state.extraUsers,
      [user.username]: {
        ...user,
      },
    };
  },
  setFavoriteUsers(state, users) {
    state.favoriteUsers = users.reduce((obj, user) => ({ ...obj, [user.username]: user }), {});
  },
  setBlockedUsers(state, users) {
    state.blockedUsers = users.reduce((obj, user) => ({ ...obj, [user.username]: user }), {});
  },
  toggleFavoriteUser(state, username) {
    if (state.favoriteUsers[username]) {
      const users = { ...state.favoriteUsers };
      delete users[username];
      state.favoriteUsers = users;
    } else {
      state.favoriteUsers = {
        ...state.favoriteUsers,
        [username]: {
          ...(state.searchedUsers[username] || state.extraUsers[username]),
          isFavorite: true,
        },
      };
    }
    if (state.searchedUsers[username]) {
      state.searchedUsers = {
        ...state.searchedUsers,
        [username]: {
          ...(state.searchedUsers[username] || state.extraUsers[username]),
          isFavorite: !state.searchedUsers[username].isFavorite,
        },
      };
    }
    if (state.extraUsers[username]) {
      state.extraUsers = {
        ...state.extraUsers,
        [username]: {
          ...state.extraUsers[username],
          isFavorite: !state.extraUsers[username].isFavorite,
        },
      };
    }
  },
  toggleBlockedUser(state, username) {
    if (state.searchedUsers[username]) {
      state.searchedUsers = {
        ...(state.searchedUsers || state.extraUsers),
        [username]: {
          ...(state.searchedUsers[username] || state.extraUsers),
          blocked: !state.searchedUsers[username].blocked,
        },
      };
    }
    if (state.favoriteUsers[username]) {
      state.favoriteUsers = {
        ...state.favoriteUsers,
        [username]: {
          ...state.favoriteUsers[username],
          blocked: !state.favoriteUsers[username].blocked,
        },
      };
    }
    if (state.blockedUsers[username]) {
      const users = { ...state.blockedUsers };
      delete users[username];
      state.blockedUsers = users;
    } else if ((state.favoriteUsers[username] || state.searchedUsers[username] || state.extraUsers[username] || { blocked: true }).blocked) {
      state.blockedUsers = {
        ...state.blockedUsers,
        [username]: {
          ...(state.favoriteUsers[username] || state.searchedUsers[username] || state.extraUsers[username]),
          isFavorite: !!state.favoriteUsers[username],
          blocked: true,
        },
      };
    }
  },
  setSelectedUser(state, username) {
    state.selectedUser = {
      ...(state.favoriteUsers[username] || state.searchedUsers[username] || state.extraUsers[username]),
      isFavorite: !!state.favoriteUsers[username],
      blocked: (state.favoriteUsers[username] || state.searchedUsers[username] || state.extraUsers[username] || { blocked: false }).blocked,
    };
  },
  setSelectedUserStats(state, { userInfo, themes }) {
    state.selectedUser = {
      ...state.selectedUser,
      userInfo,
      themes,
    };
  },
  refreshSelectedUser(state) {
    const { username } = state.selectedUser;
    state.selectedUser = {
      ...state.selectedUser,
      isFavorite: !!state.favoriteUsers[username],
      blocked: !!state.blockedUsers[username] || (state.favoriteUsers[username] || state.searchedUsers[username] || state.extraUsers[username]).blocked,
    };
  },
  clearSelectedUser(state) {
    state.selectedUser = {};
  },
  setOnlineUsers(state, users) {
    state.onlineUsers = (users) ? Object.values(users).filter(user => user.msisdn !== common.state.userDetails.msisdn) : [];
  },
  clearSearchedUsers(state) {
    state.searchedUsers = {};
  },
  setHasErrorResult(state, hasErrorResult) {
    state.searchErrorResult = hasErrorResult;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js